import React, { useCallback, useEffect, useMemo } from 'react';
import CardModal from '../molecules/CardModal/CardModal';
import { Heading } from '../atoms/Heading/Heading.styled';
import * as Styled from './EndSessionPrompt.styled';
import Paragraph from '../atoms/Paragraph/Paragraph';
import IconLabelButton, {
  IconLabelButtonTypes,
} from '../molecules/IconLabelButton/IconLabelButton';
import { useVHTypeConfig } from '../vh-types/vhTypeHooks';
import { patientSelector } from '../../slices/PatientSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
  conversationCompletePromptActiveSelector,
  markToShowEndConversationPromptWhenFinishedTalking,
  postObjectivesCompletePromptActiveSelector,
  selectAllChats,
  setConversationCompletePromptActive,
  setPostObjectivesCompletePromptActive,
  setUserEndPromptActive,
  showEndSessionModalSelector,
  userEndPromptActiveSelector,
  virtualHumanTalkingSelector,
} from '../../slices/chat/ChatSlice';
import { useTranslation } from 'react-i18next';

const EndSessionPrompt = () => {
  const vhTypeConfig = useVHTypeConfig();
  const vhDBVH = useSelector(patientSelector);
  const dispatch = useDispatch();
  const postObjectivesCompletePromptActive = useSelector(
    postObjectivesCompletePromptActiveSelector
  );
  const conversationCompletePromptActive = useSelector(
    conversationCompletePromptActiveSelector
  );
  const userEndPromptActive = useSelector(userEndPromptActiveSelector);

  const { t } = useTranslation();

  const finishPromptText = useMemo(
    () => vhTypeConfig.finishPromptText(vhDBVH),
    [vhDBVH, vhTypeConfig]
  );
  const finishWarningText = useMemo(
    () => vhTypeConfig.finishWarningText(vhDBVH),
    [vhDBVH, vhTypeConfig]
  );
  const postObjectivesCompletePromptText = useMemo(() => {
    if (vhTypeConfig.postObjectivesCompletePromptText) {
      return vhTypeConfig.postObjectivesCompletePromptText(vhDBVH);
    }
    return '';
  }, [vhDBVH, vhTypeConfig]);

  const handleClose = useCallback(() => {
    // if (postObjectivesCompletePromptActive) {
    dispatch(setPostObjectivesCompletePromptActive(false));
    // } else if (userEndPromptActive) {
    dispatch(setUserEndPromptActive(false));
    // } else if (conversationCompletePromptActive) {
    dispatch(setConversationCompletePromptActive(false));
    // }
  }, [
    // postObjectivesCompletePromptActive,
    dispatch,
    // conversationCompletePromptActive,
    // userEndPromptActive,
  ]);

  const handleEndSessionClick = useCallback(() => {
    vhTypeConfig.onFinishSession(dispatch, vhDBVH);
    dispatch(setPostObjectivesCompletePromptActive(false));
    handleClose();
  }, [dispatch, handleClose, vhDBVH, vhTypeConfig]);

  const finishButtonText = useMemo(
    () => vhTypeConfig.finishButtonText(vhDBVH),
    [vhDBVH, vhTypeConfig]
  );

  const endsConversationPromptText = useMemo(
    () => vhTypeConfig.endsConversationPromptText(vhDBVH),
    [vhDBVH, vhTypeConfig]
  );

  const headingText = useMemo(() => {
    if (postObjectivesCompletePromptActive) {
      return t('objectivesComplete');
    }
    return conversationCompletePromptActive
      ? t('conversationEnded')
      : t(finishButtonText);
  }, [
    finishButtonText,
    postObjectivesCompletePromptActive,
    conversationCompletePromptActive,
    t,
  ]);

  const paragraphText = useMemo(() => {
    if (postObjectivesCompletePromptActive) {
      return t(postObjectivesCompletePromptText);
    }
    return conversationCompletePromptActive
      ? t(endsConversationPromptText)
      : t(finishWarningText);
  }, [
    postObjectivesCompletePromptActive,
    conversationCompletePromptActive,
    t,
    endsConversationPromptText,
    finishWarningText,
    postObjectivesCompletePromptText,
  ]);

  const vhTalking = useSelector(virtualHumanTalkingSelector);

  const chats = useSelector(selectAllChats);
  useEffect(() => {
    if (chats && chats.length > 0 && chats[chats.length - 1].endsConversation) {
      dispatch(markToShowEndConversationPromptWhenFinishedTalking());
      //   if (vhTalking) {
      //   dispatch(markToShowEndConversationPromptWhenFinishedTalking());
      // } else {
      //   dispatch(setConversationCompletePromptActive(true));
      // }
    }
  }, [chats, dispatch, vhTalking]);

  const showModal = useSelector(showEndSessionModalSelector);

  return (
    <CardModal
      maxWidth="27rem"
      show={showModal}
      onHide={
        postObjectivesCompletePromptActive || conversationCompletePromptActive
          ? undefined
          : handleClose
      }
    >
      <Styled.DiagnosisModalContent>
        <Heading level="2">{headingText}</Heading>
        {/* <Heading level="3">Description</Heading> */}
        <Paragraph>{paragraphText}</Paragraph>
        <IconLabelButton
          type={IconLabelButtonTypes.BLUE}
          onClick={handleEndSessionClick}
        >
          {postObjectivesCompletePromptActive ||
          conversationCompletePromptActive
            ? t('Yes')
            : t(finishPromptText)}
        </IconLabelButton>
        <IconLabelButton onClick={handleClose}>
          {postObjectivesCompletePromptActive ||
          conversationCompletePromptActive
            ? t('notYet')
            : t('cancel')}
        </IconLabelButton>
      </Styled.DiagnosisModalContent>
    </CardModal>
  );
};

export default EndSessionPrompt;
